import {MONTHLY_PAYMENTS} from 'constants/actions';
import type {ActionType} from 'constants/flow/flowTypes';
import type {MonthlyPaymentsType} from 'constants/flow/flowTypesCart';

const initialState = {
    installments: '3',
    minTotal: '120',
    loading: true,
};

/**
 * Get information about split payments
 *
 * @param {MonthlyPaymentsType} state Current state
 * @param {ActionType<MonthlyPaymentsType>} action Received action
 * @returns {MonthlyPaymentsType} next state
 */
export default function monthlyPayments(
    state: MonthlyPaymentsType = initialState,
    action: ActionType<MonthlyPaymentsType>,
): MonthlyPaymentsType {
    switch (action.type) {
        case `${MONTHLY_PAYMENTS.GET_DATA}_FULFILLED`:
            return {...state, loading: false, ...action.payload.data};
        default:
            return state;
    }
}
